import assets from "app/assets";
import config from "config";
import { gsap, random } from "gsap";
import { BaseTexture, Container, Graphics, Sprite, Text, TextStyle, Texture } from "pixi.js";
import tools from "tools";
import DefaultObjectifBubble from "./defaultObjectifBubble";
const PIC_SIZE = 65;
export default class DefaultObjectif extends Container {
  BallGoals = [];
  constructor() {
    super();
    tools.autobind(this);
    this._build();
  }
  _build() {
    this._currentBubbleNb = 2;
    this._colorRandomStep = 0;
    this._bubbles = [];
    this._sprite = new Sprite(assets.textures.objectif.texture);
    this._sprite.anchor.set(.5);
    this._sprite.scale.set(.87);
    this.addChild(this._sprite);
    const style = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 25,
      fill: '#2c5f9a'
    });
    this._title = new Text("", style);
    this._title.anchor.set(.5);
    this._title.y = -40;
    this.addChild(this._title);
    const emojiStyle = new TextStyle({
      fontSize: 24
    });
    this._emoji = new Text("🎯", emojiStyle);
    this._emoji.anchor.y = .5;
    this._emoji.anchor.x = 1;
    this._emoji.y = -40;
    this._emoji.x = -this._title.width / 2 - 2;
    this.addChild(this._emoji);
    this.visible = false;
    config.level.on("skinsUpdate", this.skinsUpdate);
  }
  skinsUpdate() {
    this._currentBubbleNb = config.playerLevel + 1;
    if (this._currentBubbleNb > 5) {
      this._currentBubbleNb = 5;
    }
    for (let i = 0; i < this._bubbles.length; i++) {
      this._bubbles[i].destroy();
    }
    this._bubbles = [];
    let bubble;
    let nb = this._currentBubbleNb;
    let decal = nb == 2 ? 105 : nb == 3 ? 90 : nb == 4 ? 65 : 55;
    let w = decal * nb;
    let step = w / nb;
    let pos = -(step * (nb - 1)) / 2;
    let indexs = [];
    let totalValues = 0;
    for (let i = 0; i < config.level.colorsArr.length; i++) {
      indexs.push(i);
    }
    for (let i = 0; i < nb; i++) {
      let id = parseInt(tools.range(0, indexs.length - .001));
      let color = config.level.colorsArr[indexs[id]];
      bubble = new DefaultObjectifBubble(color, 30, i);
      bubble.x = pos;

      let BV = parseInt(tools.range(assets.gameConfig.minBase + this._colorRandomStep, assets.gameConfig.maxBase + this._colorRandomStep)) + (i == 4 ? totalValues : 0);
      bubble.value = BV;
      totalValues += bubble.value;
      pos += step;
      this._bubbles.push(bubble);
      this.addChild(bubble);
      indexs.splice(id, 1);
    }
    this.BallGoals = [];
    this._bubbles.forEach(bb => {
      this.BallGoals.push({
        v: bb.value,
        c: bb._color
      });
    });
    config.UpdateCount = true;
    this._allBubbleAchieved = false;
    config.level.off("skinsUpdate", this.skinsUpdate);
    config.level.on("skinsUpdate", this.skinsUpdate);
  }
  set text(val) {
    this._title.text = tools.camelCase(val);
    if (this._title.width > 154) {
      this._title.width = 154;
      this._title.scale.y = this._title.scale.x;
    }
    this._emoji.x = -this._title.width / 2;
  }
  achievedBubble(label, color) {
    //called from bubbles

    if (this._allBubbleAchieved) {
      return;
    }
    let achieved = true;
    for (let i = 0; i < this._bubbles.length; i++) {
      if (this._bubbles[i].value > 0 && (this._bubbles[i].label == label || this._bubbles[i].universal)) {
        this._bubbles[i].value--;
        this._bubbles[i].glow(color);
      }
      if (this._bubbles[i].value > 0) {
        achieved = false;
      }
    }
    this.BallGoals = [];
    this._bubbles.forEach(bb => {
      this.BallGoals.push({
        v: bb.value,
        c: bb._color
      });
    });
    config.UpdateCount = true;
    if (achieved) {
      if (config.soundOn) {
        config.AllHowlerAudios["GoalComplete"].play();
      }
      config.goalAchieved = true;
      config.gameOver = true;
      config.MovesIncProcess = true;
      this._allBubbleAchieved = true;
      this.kill(() => {
        config.level.updateCoins(config.bonusCoins3);
      }, () => {
        // if (config.gameOver) {
        //     return;
        // }

        if (this._currentBubbleNb < 5) {
          this._currentBubbleNb++;
        }
        if (this._currentBubbleNb >= assets.gameConfig.objectifPalier) {
          this._colorRandomStep += assets.gameConfig.colorRandomStepInc;
        }
        gsap.delayedCall(0.5, () => {
          config.ui.bonusMoveVal = config.bonus6;
          config.ui.scoreBonus(260, 210, 3);
          config.UpdateCount = false;
          config.UpdateCountData = {
            n: 1,
            data: []
          };
          //this.show();
          //save level
          config.playerLevel++;
          config.sdk.getStoreModule().save("level", {
            value: config.playerLevel
          });
          //save maxLevel
          let oldMaxlevel = config.MaxLevel;
          if (config.playerLevel > config.MaxLevel) {
            config.MaxLevel = config.playerLevel;
          }
          if (config.MaxLevel > oldMaxlevel) {
            config.sdk.getStoreModule().save("Maxlevel", {
              value: config.MaxLevel
            });
          }
          config.level.EndlevelAnimation();
        });
        gsap.delayedCall(0.8, () => {
          config.gameOver = false;
          config.ui.updateLevel(config.playerLevel);
          // config.ui.resetMoves(config.startMoves);
          this._allBubbleAchieved = false;
          config.defaultObjectif.active = true;
          this.skinsUpdate();
          config.touchAccess = true;
          config.goalAchieved = false;
          config.youtubePlayables && config.youtubePlayables.requestTimedInterstitial();
        });
      });
    }
  }
  labelExist(label) {
    let labelFound = false;
    let uniFound = false;
    let labelPos;
    let universalPos;
    for (let i = 0; i < this._bubbles.length; i++) {
      if (this._bubbles[i].value > 0) {
        if (this._bubbles[i].label == label) {
          labelFound = true;
          labelPos = this._bubbles[i].position;
        }
        if (this._bubbles[i].universal) {
          uniFound = true;
          universalPos = this._bubbles[i].position;
        }
      }
    }
    return {
      label: labelFound,
      universal: uniFound,
      labelPos: labelPos,
      universalPos: universalPos
    };
  }
  show() {
    this.scale.set(0);
    this.visible = true;
    gsap.to(this.scale, {
      delay: .15,
      duration: .5,
      x: 1,
      y: 1,
      ease: "back.out(1.5)"
    });
  }
  hide() {
    gsap.to(this.scale, {
      duration: .5,
      x: 0,
      y: 0,
      onComplete: () => {
        this.visible = false;
      }
    });
    this._currentBubbleNb = 2;
    this._colorRandomStep = 0;
    this._allBubbleAchieved = true;
    config.level.off("skinsUpdate", this.skinsUpdate);
  }
  kill(onStart, onComplete) {
    gsap.to(this.scale, {
      delay: 0.25,
      duration: .25,
      x: 0,
      y: 0,
      onStart: onStart,
      onComplete: () => {
        this.visible = false;
        onComplete && onComplete();
      },
      ease: "back.in(1.5)"
    });
    config.level.off("skinsUpdate", this.skinsUpdate);
  }
  reset() {
    this._currentBubbleNb = 2;
    this._colorRandomStep = 0;
  }
}
